import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';
// TODO un comment wait CRA v.5 fix.
// import 'dotenv/config'
import './utils/i18n';
import './index.scss';
import './styles/styles.scss';

import HeaderProvider  from './contexts'
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <HeaderProvider>
          <App />
        </HeaderProvider>
      </Router>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();